import { render } from "./VotesSubmit.vue?vue&type=template&id=03199fc5&scoped=true&ts=true"
import script from "./VotesSubmit.vue?vue&type=script&lang=ts"
export * from "./VotesSubmit.vue?vue&type=script&lang=ts"

import "./VotesSubmit.vue?vue&type=style&index=0&id=03199fc5&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03199fc5"]])

export default __exports__